{
  "billingAddress": "Billing Address",
  "formOfPayment": "Acceptable forms of payment include: Visa, MasterCard, American Express, JCB, Discover, and Diners Club. All payment amounts are expressed in US dollars except as otherwise noted.",
  "makePayment": "Make Payment",
  "nameOnCard": "Name on Card",
  "addNewCard": "Add New Card...",
  "defaultErrorMessage": "Unable to update your plan at the moment, please try again later.",
  "awsMarketplace": "AWS Marketplace is managing billing for your $t(common:companyName) services. Please go to <a href='https://console.aws.amazon.com/marketplace/home' target='_blank'>AWS Marketplace Console</a> to manage your subscription status.",
  "currentlyOn": "You are currently on the",
  "plan": "plan",
  "grandfathered": "grandfathered",
  "estimatedUsageThisMonth": "Your estimated usage for this month is:",
  "billingSupport": "For any billing questions, ",
  "contactUs": "reach out to us",
  "paymentSchedule": "Payment schedule:",
  "dayRetention": "day retention",
  "allFeaturesInclude": "All features included",
  "free": "Free",
  "unlimitedLiveTailVolume": "Unlimited live tail volume",
  "limitedFeatureSet": "Limited feature set",
  "minimumCharge": "minimum charge",
  "perGBMonth": "per GB / month",
  "youHaveIncentives": "You currently have additional incentives applied to your plan.",
  "downgradeToWillow": "Downgrade",
  "continue": "Continue",
  "toPayment": "to Payment",
  "switchTo": "and switch to",
  "switchSelect": "To switch to a different plan, select one from the list above.",
  "compare": "To compare plans or for more details on pricing, <a href='https://$t(common:defaultHost)/pricing' target='_blank'>visit our pricing page</a>.",
  "questions": "Need features like single-tenancy, custom retention or have questions?",
  "accountUpdated": "Your account information has been updated. Thanks!",
  "secureCheckout": "Secure Checkout",
  "paymentComplete": "Payment Complete!",
  "currentPromotion": "You are currently under the <strong>{{ code }}</strong> promotion",
  "selectedPlan": "You selected the <strong>{{ plan }} Plan</strong> - {{retention}} Day Retention at {{ rate }}/GB with ${{minCharge}} minimum charge",
  "selectedPipelinePlan": "You selected the <strong>{{ plan }} Plan</strong> - {{ rate }}/GB with ${{minCharge}} minimum charge",
  "willHaveCreditOf": "If you switch to this plan you will have a credit of {{ credit }}. This credit will be used before we charge your card.",
  "creditCardInfo": "{{ brand }} ending in {{ last4 }} (expires: {{ expires }})",
  "downgradeToFree": "Do you want to downgrade to free plan?",
  "paymentError": "Payment server failed to process your card details.",
  "couldNotValidate": "Could not validate your card details with the payment server.",
  "failedToUpdateYourPlan": "Failed to update your plan."
}
